/* istanbul ignore file */
import * as moment from 'moment';

// TODO: only create one entry per entity to improve readability

const ENGLISH_TEST_NAMES = {
  'Michigan Test (MELAB)': 'MELAB (Michigan)',
  'TOEFL': 'TOEFL',
  'IELTS': 'IELTS',
};

const COST_MAPPINGS = {
  'AVG._NET_PRICE_(INCOME_$0_30K)': 'INCOME_0_30',
  'AVG._NET_PRICE_(INCOME_$30K_48K)': 'INCOME_30_48',
  'AVG._NET_PRICE_(INCOME_$48K_75K)': 'INCOME_48_75',
  'AVG._NET_PRICE_(INCOME_$75K_110K)': 'INCOME_75_110',
  'AVG._NET_PRICE_(INCOME_>110K)': 'INCOME_GT_110',
};

const mapping = [
  {
    entity: 'he_institution_us',
    field: 'field_he_name',
    documentPath: 'college.name',
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_missionstatement',
    documentPath: 'profile.summary',
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_level',
    documentPath: 'college.level',
    map: {
      FOUR_YEAR_SCHOOL: 'FOUR_YEAR',
      TWO_YEAR_SCHOOL: 'TWO_YEAR',
      LESS_THAN_2_YEAR_SCHOOL: 'LESS_THAN_TWO_YEAR',
      CORPORATION: 'CORPORATE',
    },
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_control_id',
    documentPath: 'college.type',
    map: {
      PRIVATE_FOR_PROFIT: 'PRIVATE',
      PRIVATE_NONPROFIT: 'PRIVATE',
    },
  },
  {
    entity: 'he_institution_us',
    field: 'field_url',
    documentPath: 'profile.url',
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_city_size',
    documentPath: 'profile.citySize',
    map: {
      LARGE_CITY_GREATER_THAN_250000_POP: 'LARGE_CITY',
      MIDSIZE_CITY_GREATER_THAN_100000_POP: 'MID_CITY',
      SMALL_CITY_LESS_THAN_100000_POP: 'SMALL_CITY',
      SUBURB_NEAR_CITY_W__GREATER_THAN_250000_POP: 'LARGE_SUBURB',
      SUBURB_NEAR_CITY_W__GREATER_THAN_100000_POP: 'MID_SUBURB',
      SUBURB_NEAR_CITY_W__LESS_THAN_100000_POP: 'SMALL_SUBURB',
      TOWN_WITHIN_10_MILES_OF_URBAN_AREA: 'LARGE_TOWN',
      TOWN_10_TO_35_MILES_FROM_URBAN_AREA: 'MID_TOWN',
      TOWN_GREATER_THAN_35_MILES_FROM_URBAN_AREA: 'SMALL_TOWN',
      RURAL_WITHIN_5_MILES_OF_URBAN_AREA: 'LARGE_RURAL',
      RURAL_5_TO_25_MILES_FROM_URBAN_AREA: 'MID_RURAL',
      RURAL_GREATER_THAN_25_MILES_FROM_URBAN_AREA: 'SMALL_RURAL',
      NOT_AVAILABLE: null,
    },
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applications_accepted',
    documentPath: 'admissions.freshmanAppsAccepted',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applications_received',
    documentPath: 'admissions.freshmanAppsReceived',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    type: 'list',
    documentPath: 'admissions.admissionsPolicies',
    fields: [
      {
        field: 'field_he_admissionspolicy_id',
      },
      {
        field: 'field_he_notificationpolicy_id',
        map: {
          NO_NOTIFICATION: 'NO_NOTIFICATION_POLICY',
          NOTIFY_BY_DATE: 'BY_DATE_NOTIFICATION_POLICY',
        },
      },
      {
        field: 'field_he_registrationpolicy_id',
        map: {
          REGISTRATION_BY_APPOINTMENT_ONLY: 'BY_APPOINTMENT_REGISTRATION_POLICY',
        },
      },
      {
        field: 'field_he_earlydecision',
        map: {
          true: 'EARLY_DECISION',
          false: 'NO_EARLY_DECISION',
          null: 'UNKNOWN_EARLY_DECISION',
        },

      },
      {
        field: 'field_he_waitinglistused',
        map: {
          true: 'WAIT_LIST',
          false: 'NO_WAIT_LIST',
          null: 'UNKNOWN_WAIT_LIST',
        },

      },
    ],
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_id',
    documentPath: 'offices._embedded.officeRepresentationList',
    transform: () => [],
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_address_id',
    documentPath: 'offices._embedded.officeRepresentationList.0.type',
    transform: () => 'APPLICATION_ADDRESS',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_country_ref',
    documentPath: 'offices._embedded.officeRepresentationList.0.address.country',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_state_ref',
    documentPath: 'offices._embedded.officeRepresentationList.0.address.state',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_city',
    documentPath: 'offices._embedded.officeRepresentationList.0.address.city',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_postalcode',
    documentPath: 'offices._embedded.officeRepresentationList.0.address.postalCode',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_addressline1',
    documentPath: 'offices._embedded.officeRepresentationList.0.address.street',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_addressline2',
    documentPath: 'offices._embedded.officeRepresentationList.0.address.street2',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_emailaddress',
    documentPath: 'offices._embedded.officeRepresentationList.0.email',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_faxnumber',
    documentPath: 'offices._embedded.officeRepresentationList.0.fax',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_phonenumber',
    documentPath: 'offices._embedded.officeRepresentationList.0.phone',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_address_id',
    documentPath: 'offices._embedded.officeRepresentationList.1.type',
    transform: () => 'ADMISSIONS',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_country_ref',
    documentPath: 'offices._embedded.officeRepresentationList.1.address.country',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_state_ref',
    documentPath: 'offices._embedded.officeRepresentationList.1.address.state',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_city',
    documentPath: 'offices._embedded.officeRepresentationList.1.address.city',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_postalcode',
    documentPath: 'offices._embedded.officeRepresentationList.1.address.postalCode',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_addressline1',
    documentPath: 'offices._embedded.officeRepresentationList.1.address.street',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_addressline2',
    documentPath: 'offices._embedded.officeRepresentationList.1.address.street2',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_emailaddress',
    documentPath: 'offices._embedded.officeRepresentationList.1.email',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_faxnumber',
    documentPath: 'offices._embedded.officeRepresentationList.1.fax',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_phonenumber',
    documentPath: 'offices._embedded.officeRepresentationList.1.phone',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_jobtitle',
    documentPath: 'offices._embedded.officeRepresentationList.1.title',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_firstname',
    documentPath: 'offices._embedded.officeRepresentationList.1.firstName',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_middlename',
    documentPath: 'offices._embedded.officeRepresentationList.1.middleName',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduate_admissions_us', field: 'field_he_admissions_contact_ref' },
    field: 'field_lastname',
    documentPath: 'offices._embedded.officeRepresentationList.1.lastName',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_address_id',
    documentPath: 'offices._embedded.officeRepresentationList.2.type',
    transform: () => 'FINANCIAL_AID',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_country_ref',
    documentPath: 'offices._embedded.officeRepresentationList.2.address.country',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_state_ref',
    documentPath: 'offices._embedded.officeRepresentationList.2.address.state',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_city',
    documentPath: 'offices._embedded.officeRepresentationList.2.address.city',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_postalcode',
    documentPath: 'offices._embedded.officeRepresentationList.2.address.postalCode',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_addressline1',
    documentPath: 'offices._embedded.officeRepresentationList.2.address.street',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_addressline2',
    documentPath: 'offices._embedded.officeRepresentationList.2.address.street2',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_emailaddress',
    documentPath: 'offices._embedded.officeRepresentationList.2.email',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_faxnumber',
    documentPath: 'offices._embedded.officeRepresentationList.2.fax',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_phonenumber',
    documentPath: 'offices._embedded.officeRepresentationList.2.phone',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_jobtitle',
    documentPath: 'offices._embedded.officeRepresentationList.2.title',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_firstname',
    documentPath: 'offices._embedded.officeRepresentationList.2.firstName',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_middlename',
    documentPath: 'offices._embedded.officeRepresentationList.2.middleName',
  },
  {
    entity: 'he_contact',
    referredBy: { entity: 'he_undergraduatefinancialaid_us', field: 'field_he_finaidcontact_ref' },
    field: 'field_lastname',
    documentPath: 'offices._embedded.officeRepresentationList.2.lastName',
  },
  {
    entity: 'he_deadline_us',
    // type: 'collection',
    documentPath: 'deadlines._embedded.deadlineRepresentationList',
    fields: [
      {
        field: 'field_he_month_of_the_deadline',
        documentPath: 'date.month',
      },
      {
        field: 'field_he_day_of_the_deadline',
        documentPath: 'date.day',
      },
      {
        field: 'field_he_deadlinetype',
        documentPath: 'type',
        map: {
          REGULAR: 'REGULAR_DECISION',
        },
      },
      {
        field: 'field_he_typeotherdescription',
        documentPath: 'label',
      },
    ],
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.applicationFees',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.fees.freshmanApplicationFee',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_deposit',
    documentPath: 'admissions.fees.freshmanApplicationDeposit',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_transferappdeposit',
    documentPath: 'admissions.fees.transferApplicationDeposit',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_transferapplicationfee',
    documentPath: 'admissions.fees.transferApplicationFee',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.fees.internationalApplicationFee',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_deposit',
    documentPath: 'admissions.fees.internationalApplicationDeposit',
  },
  {
    entity: 'field_he_admission_factor_data',
    parentEntity: 'he_undergraduate_admissions_us',
    type: 'group',
    groupby: {
      field: 'field_he_importance',
    },
    documentPath: 'admissions.admissionFactors',
    fields: [
      {
        field: 'field_he_admissionfactortype',
        map: {
          ALUMNI_AE_RELATION: 'ALUMNI_RELATION',
        },
      },
    ],
  },
  {
    entity: 'he_specialservice_us',
    type: 'list',
    documentPath: 'profile.studentLife.rotc',
    transform: (value, values, metadata) => value.reduce((result, item) => {
      const key = Object.keys(item)[0];
      result[key] = item[key];
      return result;
    }, {}),
    fields: [
      {
        field: 'field_he_rotcservperoppcollege',
        map: {
          true: { SERVICEPERSON_OPPORTUNITY_COLLEGE: true },
          false: { SERVICEPERSON_OPPORTUNITY_COLLEGE: false },
          null: { SERVICEPERSON_OPPORTUNITY_COLLEGE: false },
        },
      },
      {
        field: 'field_he_rotcarmy',
        map: {
          true: { ARMY: true },
          false: { ARMY: false },
          null: { ARMY: false },
        },
      },
      {
        field: 'field_he_rotcnavy',
        map: {
          true: { NAVY: true },
          false: { NAVY: false },
          null: { NAVY: false },
        },
      },
      {
        field: 'field_he_rotcair',
        map: {
          true: { AIRFORCE: true },
          false: { AIRFORCE: false },
          null: { AIRFORCE: false },
        },
      },
    ],
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_internetincentralloc',
    documentPath: 'profile.studentLife.computingEnvironment.internetAccess.CENTRAL_CAMPUS',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_internetinresidencehall',
    documentPath: 'profile.studentLife.computingEnvironment.internetAccess.RESIDENCE_HALLS',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_internetinlibrary',
    documentPath: 'profile.studentLife.computingEnvironment.internetAccess.LIBRARY',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_internetwireless',
    documentPath: 'profile.studentLife.computingEnvironment.internetAccess.WIRELESS',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_macsincomputercen',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.COMPUTER_CENTERS.numberOfMacs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_pcsincomputercenters',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.COMPUTER_CENTERS.numberOfPCs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_macsindepartmentlabs',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.DEPARTMENT_LABS.numberOfMacs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_pcsindepartmentlabs',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.DEPARTMENT_LABS.numberOfPCs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_macsinlibrary',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.LIBRARY.numberOfMacs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_pcsinlibrary',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.LIBRARY.numberOfPCs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_macsinstudentcenters',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.STUDENT_CENTERS.numberOfMacs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_pcsinstudentcenters',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.STUDENT_CENTERS.numberOfPCs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_macsinresidences',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.RESIDENCE.numberOfMacs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_pcsinresidences',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.RESIDENCE.numberOfPCs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_macsinother',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.OTHER.numberOfMacs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_pcsinother',
    documentPath: 'profile.studentLife.computingEnvironment.computerQuantities.OTHER.numberOfPCs',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_computerrequired',
    documentPath: 'profile.studentLife.computingEnvironment.computerPolicy.computerRequired',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_computerrequiredreason',
    documentPath: 'profile.studentLife.computingEnvironment.computerPolicy.computerRequiredReason',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_purchaseplanoffered',
    documentPath: 'profile.studentLife.computingEnvironment.computerPolicy.computerPurchasePlanOffered',
  },
  {
    entity: 'he_computingenvironment_us',
    field: 'field_he_prefered_computer_type',
    documentPath: 'profile.studentLife.computingEnvironment.computerPolicy.computerTypePreferred',
    transform: (value, values, metadata) => {
      if (!value) {
        return null;
      }
      return value.replace('NO DATA', 'No data').replace('MACINTOSH(TM)', 'Macintosh(tm)');
    },
  },
  {
    entity: 'he_housing_us',
    field: 'field_he_camphouscap',
    documentPath: 'profile.housing.campusHousingCapacity',
  },
  {
    entity: 'he_housing_us',
    type: 'list',
    documentPath: 'profile.housing.housingPolicies',
    fields: [
      {
        field: 'field_he_freshmenmustliveoncampu',
        map: {
          true: 'FRESHMAN_REQUIRED_LIVE_ON_CAMPUS',
          false: 'NO_FRESHMAN_REQUIRED_LIVE_ON_CAMPUS',
          null: 'UNKNOWN_FRESHMAN_REQUIRED_LIVE_ON_CAMPUS',
        },
      },
      {
        field: 'field_he_sophomoresmustliveoncam',
        map: {
          true: 'SOPHOMORES_REQUIRED_LIVE_ON_CAMPUS',
          false: 'NO_SOPHOMORES_REQUIRED_LIVE_ON_CAMPUS',
          null: 'UNKNOWN_SOPHOMORES_REQUIRED_LIVE_ON_CAMPUS',
        },
      },
      {
        field: 'field_he_juniorsmustliveoncampus',
        map: {
          true: 'JUNIORS_REQUIRED_LIVE_ON_CAMPUS',
          false: 'NO_JUNIORS_REQUIRED_LIVE_ON_CAMPUS',
          null: 'UNKNOWN_JUNIORS_REQUIRED_LIVE_ON_CAMPUS',
        },
      },
      {
        field: 'field_he_seniorsmustliveoncampus',
        map: {
          true: 'SENIORS_REQUIRED_LIVE_ON_CAMPUS',
          false: 'NO_SENIORS_REQUIRED_LIVE_ON_CAMPUS',
          null: 'UNKNOWN_SENIORS_REQUIRED_LIVE_ON_CAMPUS',
        },
      },
    ],
  },
  {
    entity: 'he_studentorganization_us',
    field: 'field_he_numsocialsor',
    documentPath: 'profile.studentLife.greekSororities',
  },
  {
    entity: 'he_studentorganization_us',
    field: 'field_he_numsocialfrat',
    documentPath: 'profile.studentLife.greekFraternities',
  },
  {
    entity: 'he_studentorganization_us',
    field: 'field_he_orgrepresented',
    transform: (value, values, metadata) => {
      const newValue = [];
      value.forEach((v) => {
        newValue.push({ name: v, available: true });
      });
      return newValue;
    },
    documentPath: 'profile.studentLife.organizations',
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_nearestcity',
    documentPath: 'profile.nearestMajorCity',
  },
  {
    entity: 'he_institution_us',
    field: 'field_he_nearestmajorcitymiles',
    documentPath: 'profile.milesToMajorCity',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctliveoncamp',
    documentPath: 'profile.demographics.percentLiveOnCampus',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctinternational',
    documentPath: 'profile.demographics.ethnicDiversity.INTERNATIONAL',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctafricanam',
    documentPath: 'profile.demographics.ethnicDiversity.AFRICAN_AMERICAN',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pcthispanic',
    documentPath: 'profile.demographics.ethnicDiversity.HISPANIC',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctnativepacificisland',
    documentPath: 'profile.demographics.ethnicDiversity.NATIVE_PACIFIC_ISLANDER',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pcttwoormoreraces',
    documentPath: 'profile.demographics.ethnicDiversity.TWO_OR_MORE',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctcaucasian',
    documentPath: 'profile.demographics.ethnicDiversity.CAUCASIAN',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctasian',
    documentPath: 'profile.demographics.ethnicDiversity.ASIAN',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctnativeam',
    documentPath: 'profile.demographics.ethnicDiversity.NATIVE_AMERICAN',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctnonresidentalien',
    documentPath: 'profile.demographics.ethnicDiversity.NON_RESIDENT_ALIEN',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctraceunknown',
    documentPath: 'profile.demographics.ethnicDiversity.RACE_UNKNOWN',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctstudentsgt24yrsold',
    documentPath: 'profile.demographics.ageDiversity.OVER_24',
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_pctstudentsgt24yrsold',
    documentPath: 'profile.demographics.ageDiversity.UNDER_24',
    transform: (value, values, metadata) => {
      const inverse = 100 - value;
      return inverse;
    },
  },
  {
    entity: 'he_student_body_us',
    field: 'field_he_studentfacultyratio',
    documentPath: 'profile.demographics.studentFacultyRatio',
  },
  {
    entity: 'he_student_body_us',
    documentPath: 'profile.demographics.undergraduateEnrollment',
    type: 'list',
    transform: (value, values, metadata) => {
      if (value && value.length > 0) {
        let total = 0;
        value.forEach((val) => {
          total += val;
        });
        return total;
      } else {
        return null;
      }
    },
    fields: [
      {
        field: 'field_he_numugmales',
      },
      {
        field: 'field_he_numugfemales',
      },
    ],
  },
  {
    entity: 'he_student_body_us',
    documentPath: 'profile.demographics.graduateEnrollment',
    type: 'list',
    transform: (value, values, metadata) => {
      if (value && value.length > 0) {
        let total = 0;
        value.forEach((val) => {
          total += val;
        });
        return total;
      } else {
        return null;
      }
    },
    fields: [
      {
        field: 'field_he_numgradmales',
      },
      {
        field: 'field_he_numgradfemales',
      },
    ],
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applications_accepted',
    documentPath: 'admissions.freshmanAppsAccepted',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applications_received',
    documentPath: 'admissions.freshmanAppsReceived',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    type: 'list',
    documentPath: 'admissions.admissionsPolicies',
    fields: [
      {
        field: 'field_he_admissionspolicy_id',
      },
      {
        field: 'field_he_notificationpolicy_id',
        map: {
          NO_NOTIFICATION: 'NO_NOTIFICATION_POLICY',
        },

      },
      {
        field: 'field_he_registrationpolicy_id',
        map: {
          REGISTRATION_BY_APPOINTMENT_ONLY: 'BY_APPOINTMENT_REGISTRATION_POLICY',
        },
      },
      {
        field: 'field_he_earlydecision',
        map: {
          true: 'EARLY_DECISION',
          false: 'NO_EARLY_DECISION',
          null: 'UNKNOWN_EARLY_DECISION',
        },

      },
      {
        field: 'field_he_waitinglistused',
        map: {
          true: 'WAIT_LIST',
          false: 'NO_WAIT_LIST',
          null: 'UNKNOWN_WAIT_LIST',
        },

      },
    ],
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_retentionratefulltime',
    documentPath: 'profile.demographics.studentRetention',
  },
  {
    entity: 'he_student_body_us',
    type: 'list',
    documentPath: 'profile.popularAreasOfStudy',
    fields: [
      {
        field: 'field_he_popularareaofstudy1',
      },
      {
        field: 'field_he_popularareaofstudy2',
      },
      {
        field: 'field_he_popularareaofstudy3',
      },
      {
        field: 'field_he_popularareaofstudy4',
      },
      {
        field: 'field_he_popularareaofstudy5',
      },
    ],
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.fees.internationalApplicationFee',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_englishcompetencytestid',
    documentPath: 'admissions.acceptedLanguageTests',
    transform: (value, values, metadata) =>
      (values || []).map((v) => ENGLISH_TEST_NAMES[metadata.allowed_values[v.value]]),
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_deposit',
    documentPath: 'admissions.fees.internationalApplicationDeposit',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_applications_accepted',
    documentPath: 'admissions.internationalAppsAccepted',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_applications_received',
    documentPath: 'admissions.internationalAppsReceived',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_applications_enrolled',
    documentPath: 'admissions.internationalAppsEnrolled',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_deadline',
    documentPath: 'admissions.internationalApplicationDeadline',
    transform: (value, values, metadata) => {
      let m;
      if (Number.isNaN(value)) {
        m = moment(value.date, 'MM/DD/YYYY');
      } else {
        value = (value.length > 10) ? value.substring(0, 10) : value;
        m = moment.unix(value);
      }
      return m.format('YYYY-MM-DD');
    },
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.applicationFees',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.fees.freshmanApplicationFee',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_deposit',
    documentPath: 'admissions.fees.freshmanApplicationDeposit',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_transferappdeposit',
    documentPath: 'admissions.fees.transferApplicationDeposit',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_transferapplicationfee',
    documentPath: 'admissions.fees.transferApplicationFee',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_applicationfee',
    documentPath: 'admissions.fees.internationalApplicationFee',
  },
  {
    entity: 'he_internationaladmissions_us',
    field: 'field_he_deposit',
    documentPath: 'admissions.fees.internationalApplicationDeposit',
  },
  {
    entity: 'he_specialservice_us',
    field: 'field_he_special_services_id_ref',
    transform: (value, values, metadata) => {
      const hiddenItems = ['47', '48', '49', '50', '51', '52'];
      const newValue = [];
      for (let i = 0; i < value.length; i +=1) {
        if (!hiddenItems.includes(values[i].target_id)) {
          newValue.push({ name: value[i], available: true });
        }
      }
      return newValue;
    },
    documentPath: 'profile.studentLife.basicServices',
  },
  {
    entity: 'he_specialservice_us',
    type: 'list',
    documentPath: 'profile.studyOptions',
    transform: (value, values, metadata) =>
      value.reduce((result, item) => {
        if (Array.isArray(item)) {
          const keys = Object.keys(item[0]);
          for (let i = 0; i < keys.length; i +=1) {
            result[keys[i]] = item[0][keys[i]];
          }
        } else {
          const key = Object.keys(item)[0];
          result[key] = item[key];
        }
        return result;
      }, {}),
    fields: [
      {
        field: 'field_he_special_services_id_ref',
        transform: (value, values, metadata) => {
          const shownItems = ['47', '48', '49', '50', '51', '52'];
          const objsArray = [];
          const newObj = {};

          shownItems.forEach((item) => {
            let found = false;
            for (let i = 0; i < value.length; i +=1) {
              if (item === values[i].target_id) {
                newObj[value[i]] = true;
                found = true;
                break;
              }
            }

            if (!found) {
              newObj[metadata.allowed_values[item]] = false;
            }
            objsArray.push(newObj);
          });

          return objsArray;
        },
      },
      {
        field: 'field_he_teachercertpgms',
        map: {
          true: { TEACHER_CERTIFICATION_PROGRAMS: true },
          false: { TEACHER_CERTIFICATION_PROGRAMS: false },
          null: { TEACHER_CERTIFICATION_PROGRAMS: false },
        },
      },
      {
        field: 'field_he_combineddegreepgms',
        map: {
          true: { COMBINED_DEGREE_PROGRAMS: true },
          false: { COMBINED_DEGREE_PROGRAMS: false },
          null: { COMBINED_DEGREE_PROGRAMS: false },
        },
      },
      {
        field: 'field_he_domstudyawaypgms',
        map: {
          true: { DOMESTIC_STUDY_AWAY_PROGRAMS: true },
          false: { DOMESTIC_STUDY_AWAY_PROGRAMS: false },
          null: { DOMESTIC_STUDY_AWAY_PROGRAMS: false },
        },
      },
      {
        field: 'field_he_weekendeveningpgms',
        map: {
          true: { WEEKEND_EVENING_PROGRAMS: true },
          false: { WEEKEND_EVENING_PROGRAMS: false },
          null: { WEEKEND_EVENING_PROGRAMS: false },
        },
      },
      {
        field: 'field_he_acceleratedprogram',
        map: {
          true: { ACCELERATED_PROGRAM: true },
          false: { ACCELERATED_PROGRAM: false },
          null: { ACCELERATED_PROGRAM: false },
        },
      },
      {
        field: 'field_he_doublemajor',
        map: {
          true: { DOUBLE_MAJOR: true },
          false: { DOUBLE_MAJOR: false },
          null: { DOUBLE_MAJOR: false },
        },
      },
      {
        field: 'field_he_externaldegreeprogram',
        map: {
          true: { EXTERNAL_DEGREE_PROGRAM: true },
          false: { EXTERNAL_DEGREE_PROGRAM: false },
          null: { EXTERNAL_DEGREE_PROGRAM: false },
        },
      },
      {
        field: 'field_he_honorsprogram',
        map: {
          true: { HONORS_PROGRAM: true },
          false: { HONORS_PROGRAM: false },
          null: { HONORS_PROGRAM: false },
        },
      },
      {
        field: 'field_he_independentstudy',
        map: {
          true: { INDEPENDENT_STUDY: true },
          false: { INDEPENDENT_STUDY: false },
          null: { INDEPENDENT_STUDY: false },
        },
      },
      {
        field: 'field_he_internships',
        map: {
          true: { INTERNSHIPS: true },
          false: { INTERNSHIPS: false },
          null: { INTERNSHIPS: false },
        },
      },
      {
        field: 'field_he_weekendcollege',
        map: {
          true: { WEEKEND_COLLEGE: true },
          false: { WEEKEND_COLLEGE: false },
          null: { WEEKEND_COLLEGE: false },
        },
      },
      {
        field: 'field_he_cooperativeedupgms',
        map: {
          true: { COOPERATIVE_EDUCATION_PROGRAMS: true },
          false: { COOPERATIVE_EDUCATION_PROGRAMS: false },
          null: { COOPERATIVE_EDUCATION_PROGRAMS: false },
        },
      },
    ],
  },
  {
    entity: 'he_schoolsport_us',
    // type: 'collection',
    documentPath: 'profile.studentLife.sports',
    fields: [
      {
        field: 'field_he_sport_name',
        documentPath: 'name',
        transform: (value, values, metadata) => {
          if (!value) {
            return '';
          }
          return value.toLowerCase().replace(/_/g, ' ').replace(/(\b[a-z])/g, (m) => m[0].toUpperCase());
        },
      },
      {
        field: 'field_he_assocmen_id',
        documentPath: 'schoolSports.MEN.association',
      },
      {
        field: 'field_he_confmen_id',
        documentPath: 'schoolSports.MEN.conference',
      },
      {
        field: 'field_he_divmen_id',
        documentPath: 'schoolSports.MEN.division',
        transform: (value, values, metadata) => {
          if (!value) {
            return '';
          }
          return value.replace('DIVISION_', 'Division ').replace(/_/g, ' ');
        },
      },
      {
        field: 'field_he_clubmen',
        documentPath: 'schoolSports.MEN.club',
      },
      {
        field: 'field_he_intramuralmen',
        documentPath: 'schoolSports.MEN.intramural',
      },
      {
        field: 'field_he_assocwomen_id',
        documentPath: 'schoolSports.WOMEN.association',
      },
      {
        field: 'field_he_confwomen_id',
        documentPath: 'schoolSports.WOMEN.conference',
      },
      {
        field: 'field_he_divwomen_id',
        documentPath: 'schoolSports.WOMEN.division',
        transform: (value, values, metadata) => {
          if (!value) {
            return '';
          }
          return value.replace('DIVISION_', 'Division ').replace(/_/g, ' ');
        },
      },
      {
        field: 'field_he_clubwomen',
        documentPath: 'schoolSports.WOMEN.club',
      },
      {
        field: 'field_he_intramuralwomen',
        documentPath: 'schoolSports.WOMEN.intramural',
      },
      {
        field: 'field_he_assoccoed_id',
        documentPath: 'schoolSports.COED.association',
      },
      {
        field: 'field_he_confcoed_id',
        documentPath: 'schoolSports.COED.conference',
      },
      {
        field: 'field_he_divcoed_id',
        documentPath: 'schoolSports.COED.division',
        transform: (value, values, metadata) => {
          if (!value) {
            return '';
          }
          return value.replace('DIVISION_', 'Division ').replace(/_/g, ' ');
        },
      },
      {
        field: 'field_he_clubcoed',
        documentPath: 'schoolSports.COED.club',
      },
      {
        field: 'field_he_intramuralcoed',
        documentPath: 'schoolSports.COED.intramural',
      },
      {
        entity: 'he_schoolsport_us',
        type: 'list',
        documentPath: 'schoolSports.MEN.varsity',
        transform: (value, values, metadata) => {
          let varsity = false;
          if (value && value.length > 0) {
            value.forEach((val) => {
              if (value) {
                varsity = true;
              }
            });
          }
          return varsity;
        },
        fields: [
          {
            field: 'field_he_assocmen_id',
          },
          {
            field: 'field_he_divmen_id',
          },
          {
            field: 'field_he_confmen_id',
          },
        ],
      },
      {
        entity: 'he_schoolsport_us',
        type: 'list',
        documentPath: 'schoolSports.WOMEN.varsity',
        transform: (value, values, metadata) => {
          let varsity = false;
          if (value && value.length > 0) {
            value.forEach((val) => {
              if (value) {
                varsity = true;
              }
            });
          }
          return varsity;
        },
        fields: [
          {
            field: 'field_he_assocwomen_id',
          },
          {
            field: 'field_he_divwomen_id',
          },
          {
            field: 'field_he_confwomen_id',
          },
        ],
      },
      {
        entity: 'he_schoolsport_us',
        type: 'list',
        documentPath: 'schoolSports.COED.varsity',
        transform: (value, values, metadata) => {
          let varsity = false;
          if (value && value.length > 0) {
            value.forEach((val) => {
              if (value) {
                varsity = true;
              }
            });
          }
          return varsity;
        },
        fields: [
          {
            field: 'field_he_assoccoed_id',
          },
          {
            field: 'field_he_divcoed_id',
          },
          {
            field: 'field_he_confcoed_id',
          },
        ],
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.averageNetPrices',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const newValues = value.UNDERGRADUATE.reduce((current, costs) => {
        const hubsCost = COST_MAPPINGS[costs.field_he_financialaidprofiletype];
        if (hubsCost) {
          current[hubsCost] = costs.field_he_value;
        }
        return current;
      }, {});
      return newValues;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.percentReceivingGrantAid',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const cost = value.UNDERGRADUATE.filter((val) => val.field_he_financialaidprofiletype === '%_RECEIVING_GRANT_AID');
      if (cost.length > 0) {
        return Number(cost[0].field_he_value);
      }
      return null;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.percentReceivingPellGrantAid',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const cost = value.UNDERGRADUATE.filter((val) =>
        val.field_he_financialaidprofiletype === '%_RECEIVING_PELL_GRANT_AID');

      if (cost.length > 0) {
        return Number(cost[0].field_he_value);
      }
      return null;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.percentReceivingFederalStudentLoan',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const cost = value.UNDERGRADUATE.filter((val) =>
        val.field_he_financialaidprofiletype === '%_RECEIVING_FEDERAL_STUDENT_LOAN');
      if (cost.length > 0) {
        return Number(cost[0].field_he_value);
      }
      return null;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.averageGrantAidAmt',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const cost = value.UNDERGRADUATE.filter((val) => val.field_he_financialaidprofiletype === 'AVG._GRANT_AMOUNT');
      if (cost.length > 0) {
        return Number(cost[0].field_he_value);
      }
      return null;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.averagePellGrantAidAmt',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const cost = value.UNDERGRADUATE.filter((val) => val.field_he_financialaidprofiletype === 'AVG._PELL_GRANT_AMOUNT');
      if (cost.length > 0) {
        return Number(cost[0].field_he_value);
      }
      return null;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_financial_profile',
    parentEntity: 'he_undergraduatefinancialaid_us',
    documentPath: 'tuition.averageFedStudentLoanAmt',
    type: 'group',
    groupby: {
      field: 'field_he_finaidgroupappliedto',
    },
    transform: (value, values, metadata) => {
      if (!value.UNDERGRADUATE) {
        return null;
      }
      const cost = value.UNDERGRADUATE.filter((val) =>
        val.field_he_financialaidprofiletype === 'AVG._FEDERAL_STUDENT_LOAN_AMOUNT');
      if (cost.length > 0) {
        return Number(cost[0].field_he_value);
      }
      return null;
    },
    fields: [
      {
        field: 'field_he_financialaidprofiletype',
      },
      {
        field: 'field_he_value',
      },
    ],
  },
  {
    entity: 'field_he_qualification_data_us',
    parentEntity: 'he_internationaladmissions_us',
    documentPath: 'admissions.internationalApplicationRequirements',
    type: 'group',
    groupby: {
      field: 'field_he_qualification_grouping',
    },
    transform: (value, values, metadata) => {
      let newValues = {
        OPTIONAL: [],
        REQUIRED: [],
        RECOMMENDED: [],
      };

      if (value.INTERNATIONAL) {
        newValues = value.INTERNATIONAL.reduce((current, qual) => {
          const type = qual.field_he_qualification_type;
          const reqOptRecommend = qual.field_he_requiredoptrecommend;
          if (reqOptRecommend === 'OPTIONAL') {
            newValues.OPTIONAL.push(type);
          } else if (reqOptRecommend === 'REQUIRED') {
            newValues.REQUIRED.push(type);
          } else if (reqOptRecommend === 'RECOMMENDED') {
            newValues.RECOMMENDED.push(type);
          }

          return current;
        }, newValues);
      }
      return newValues;
    },
    fields: [
      {
        field: 'field_he_qualification_type',
      },
      {
        field: 'field_he_requiredoptrecommend',
        map: {
          null: 'NONE',
          NEITHER_REQUIRED_NOR_RECOMMENDED: 'OPTIONAL',
          NOT_APPLICABLE: 'NONE',
        },
      },
    ],
  },
  {
    entity: 'field_he_qualification_data_us',
    parentEntity: 'he_undergraduate_admissions_us',
    documentPath: 'admissions.freshmanApplicationRequirements',
    type: 'group',
    groupby: {
      field: 'field_he_qualification_grouping',
    },
    transform: (value, values, metadata) => {
      let newValues = {
        OPTIONAL: [],
        REQUIRED: [],
        RECOMMENDED: [],
      };

      if (value.FRESHMAN) {
        newValues = value.FRESHMAN.reduce((current, qual) => {
          const type = qual.field_he_qualification_type;
          const reqOptRecommend = qual.field_he_requiredoptrecommend;
          if (reqOptRecommend === 'OPTIONAL') {
            newValues.OPTIONAL.push(type);
          } else if (reqOptRecommend === 'REQUIRED') {
            newValues.REQUIRED.push(type);
          } else if (reqOptRecommend === 'RECOMMENDED') {
            newValues.RECOMMENDED.push(type);
          }

          return current;
        }, newValues);
      }
      return newValues;
    },
    fields: [
      {
        field: 'field_he_qualification_type',
      },
      {
        field: 'field_he_requiredoptrecommend',
        map: {
          null: 'NONE',
          NEITHER_REQUIRED_NOR_RECOMMENDED: 'OPTIONAL',
          NOT_APPLICABLE: 'NONE',
        },
      },
    ],
  },
  {
    entity: 'field_he_qualification_data_us',
    parentEntity: 'he_undergraduate_admissions_us',
    documentPath: 'admissions.transferApplicationRequirements',
    type: 'group',
    groupby: {
      field: 'field_he_qualification_grouping',
    },
    transform: (value, values, metadata) => {
      let newValues = {
        OPTIONAL: [],
        REQUIRED: [],
        RECOMMENDED: [],
      };

      if (value.TRANSFER) {
        newValues = value.TRANSFER.reduce((current, qual) => {
          const type = qual.field_he_qualification_type;
          const reqOptRecommend = qual.field_he_requiredoptrecommend;
          if (reqOptRecommend === 'OPTIONAL') {
            newValues.OPTIONAL.push(type);
          } else if (reqOptRecommend === 'REQUIRED') {
            newValues.REQUIRED.push(type);
          } else if (reqOptRecommend === 'RECOMMENDED') {
            newValues.RECOMMENDED.push(type);
          }

          return current;
        }, newValues);
      }
      return newValues;
    },
    fields: [
      {
        field: 'field_he_qualification_type',
      },
      {
        field: 'field_he_requiredoptrecommend',
        map: {
          null: 'NONE',
          NEITHER_REQUIRED_NOR_RECOMMENDED: 'OPTIONAL',
          NOT_APPLICABLE: 'NONE',
        },
      },
    ],
  },
  {
    entity: 'field_he_test_us',
    parentEntity: 'he_internationaladmissions_us',
    documentPath: 'admissions.acceptedInternationalComparisonScores',
    type: 'group',
    groupby: {
      field: 'field_he_testgroup_id',
    },
    transform: (value, values, metadata) => {
      if (!value.INTERNATIONAL) {
        return null;
      }
      const newValues = value.INTERNATIONAL.reduce((current, test) => {
        const type = test.field_he_testtype_id;
        current[type] = {
          low: test.field_he_low,
          average: test.field_he_average,
          high: test.field_he_high_score,
        };
        return current;
      }, {});
      return newValues;
    },
    fields: [
      {
        field: 'field_he_testtype_id',
        map: {
          'TOEFL_(PAPER)': 'TOEFL_PAPER',
          'TOEFL_(INTERNET)': 'TOEFL_INTERNET',
          'TOEFL_(COMPUTER)': 'TOEFL_COMPUTER',
          'IELTS_(PAPER)': 'IELTS_PAPER',
          'IELTS_(COMPUTER)': 'IELTS_COMPUTER',
          'MICHIGAN_(MELAB)': 'MELAB',
        },
      },
      {
        field: 'field_he_low',
      },
      {
        field: 'field_he_average',
      },
      {
        field: 'field_he_high_score',
      },
    ],
  },
  {
    entity: 'field_he_test_us',
    parentEntity: 'he_undergraduate_admissions_us',
    documentPath: 'admissions.acceptedFreshmanComparisonScoresNew',
    type: 'group',
    groupby: {
      field: 'field_he_testgroup_id',
    },
    transform: (value, values, metadata) => {
      let newValues = {};
      if (value.UNDERGRADUATE) {
        // TODO: Do concordance for SAT scores like how we would do in HUBS
        newValues = value.UNDERGRADUATE.reduce((current, test) => {
          const type = test.field_he_testtype_id;
          current[type] = {
            low: test.field_he_low,
            average: test.field_he_average,
            high: test.field_he_high_score,
          };
          return current;
        }, {});
      }
      newValues.GPA_CUMULATIVE = {};
      return newValues;
    },
    fields: [
      {
        field: 'field_he_testtype_id',
        map: {
          SAT_CRITICAL_READING: 'SAT_2400_READING',
          SAT_MATH: 'SAT_2400_MATH',
          SAT_COMBINED: 'SAT_2400_COMBINED',
          SAT_WRITING: 'SAT_2400_WRITING',
        },
      },
      {
        field: 'field_he_low',
      },
      {
        field: 'field_he_average',
      },
      {
        field: 'field_he_high_score',
      },
    ],
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_gpaaverage',
    documentPath: 'admissions.acceptedFreshmanComparisonScoresNew.GPA_CUMULATIVE.average',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_gpa_25th_percentile',
    documentPath: 'admissions.acceptedFreshmanComparisonScoresNew.GPA_CUMULATIVE.25',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_gpa_75th_percentile',
    documentPath: 'admissions.acceptedFreshmanComparisonScoresNew.GPA_CUMULATIVE.75',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_gradratebachelors4yrs',
    documentPath: 'profile.demographics.graduationRate4',
  },
  {
    entity: 'he_undergraduate_admissions_us',
    field: 'field_he_gradratebachelors6yrs',
    documentPath: 'profile.demographics.graduationRate6',
  },
  {
    entity: 'field_he_highschoolprerequisites',
    parentEntity: 'he_undergraduate_admissions_us',
    documentPath: 'admissions.prerequisiteCourses',
    type: 'group',
    groupby: {
      field: 'field_he_prerequisitetype',
    },
    transform: (value, values, metadata) => {
      let newValues = {
        REQUIRED: {},
        RECOMMENDED: {},
      };
      newValues = Object.keys(value).reduce((current, course) => {
        if (value[course][0].field_he_yearsrequired > 0) {
          newValues.REQUIRED[course] = value[course][0].field_he_yearsrequired;
        }
        if (value[course][0].field_he_yearsrecommended > 0) {
          newValues.RECOMMENDED[course] = value[course][0].field_he_yearsrecommended;
        }
        return current;
      }, newValues);
      return newValues;
    },
    fields: [
      {
        field: 'field_he_yearsrequired',
      },
      {
        field: 'field_he_yearsrecommended',
        map: {
          null: 'NONE',
          NEITHER_REQUIRED_NOR_RECOMMENDED: 'OPTIONAL',
          NOT_APPLICABLE: 'NONE',
        },
      },
    ],
  },
  {
    entity: 'he_student_body_us',
    documentPath: 'profile.demographics.genderDiversity',
    type: 'list',
    transform: (value) => {
      if (value && value.length > 0) {
        let total = 0;
        let numMales = 0;
        let numFemales = 0;
        value.forEach((val) => {
          total += val.value;
          if (val.field === 'numugmales') {
            numMales += val.value;
          } else if (val.field === 'numugfemales') {
            numFemales += val.value;
          }
        });
        return { MALE: Math.round((numMales / total) * 100), FEMALE: Math.round((numFemales / total) * 100) };
      } else {
        return null;
      }
    },
    fields: [
      {
        field: 'field_he_numugmales',
        transform: (value) => {
          const field = 'numugmales';
          return { field, value };
        },
      },
      {
        field: 'field_he_numugfemales',
        transform: (value) => {
          const field = 'numugfemales';
          return { field, value };
        },
      },
    ],
  },
];

export default mapping;
